import { message } from 'antd';
import axios, { CancelTokenSource } from 'axios';
import BaseEntity from '../base/BaseEntity';
import Filter from '../base/filter/Filter';
import HttpUtil from '../../util/HttpUtil';
import FileUtil from '../../util/FileUtil';
import ImageUtil from '../../util/ImageUtil';
import EnvUtil from '../../util/EnvUtil';
import InputFilter from '../base/filter/InputFilter';
import CheckFilter from '../base/filter/CheckFilter';
import SortFilter from '../base/filter/SortFilter';
import MimeUtil from '../../util/MimeUtil';
import StringUtil from '../../util/StringUtil';
import NumberUtil from '../../util/NumberUtil'; 
import SafeUtil from '../../util/SafeUtil';
import ImagePreviewer from '../../../pages/widget/previewer/ImagePreviewer';
import MessageBoxUtil from '../../util/MessageBoxUtil';
import PreviewerHelper from '../../../pages/widget/previewer/PreviewerHelper';
import HttpBase from '../base/HttpBase';
import User from "../user/User";
import Lang from '../global/Lang';
import Preference from '../preference/Preference';

export default class Matter extends BaseEntity {

  // 禁止扩展名缓存（避免每个文件都请求一次 /api/preference/fetch）
  private static _forbiddenExtCache: { enabled: boolean; extensions: string[] } | null = null;
  private static _forbiddenExtCacheTime: number = 0;
  private static _forbiddenExtPending: Promise<{ enabled: boolean; extensions: string[] }> | null = null;
  private static FORBIDDEN_EXT_CACHE_TTL = 60000; // 1分钟

  static async fetchForbiddenExtensions(): Promise<{ enabled: boolean; extensions: string[] }> {
    const now = Date.now();
    if (Matter._forbiddenExtCache && (now - Matter._forbiddenExtCacheTime) < Matter.FORBIDDEN_EXT_CACHE_TTL) {
      return Matter._forbiddenExtCache;
    }
    if (Matter._forbiddenExtPending) {
      return Matter._forbiddenExtPending;
    }
    Matter._forbiddenExtPending = new Promise((resolve) => {
      HttpUtil.httpGet(Preference.URL_API_PREFERENCE_FETCH, {}, function (response: any) {
        const preference = response.data?.data;
        if (preference && preference.forbiddenExtensionsEnabled && preference.forbiddenExtensions) {
          const extensions = preference.forbiddenExtensions.split(',').map((ext: string) => {
            let cleaned = ext.trim().toLowerCase();
            if (!cleaned.startsWith('.')) cleaned = '.' + cleaned;
            return cleaned;
          });
          Matter._forbiddenExtCache = { enabled: true, extensions };
        } else {
          Matter._forbiddenExtCache = { enabled: false, extensions: [] };
        }
        Matter._forbiddenExtCacheTime = Date.now();
        Matter._forbiddenExtPending = null;
        resolve(Matter._forbiddenExtCache);
      }, function () {
        Matter._forbiddenExtCache = { enabled: false, extensions: [] };
        Matter._forbiddenExtCacheTime = Date.now();
        Matter._forbiddenExtPending = null;
        resolve(Matter._forbiddenExtCache);
      });
    });
    return Matter._forbiddenExtPending;
  }

  static invalidateForbiddenExtCache() {
    Matter._forbiddenExtCache = null;
  }

  puuid: string = '';
  userUuid: string = '';
  dir: boolean = false;
  alien: boolean = false;
  name: string = '';
  md5: string | null = null;
  size: number = 0;
  privacy: boolean = true;
  path: string | null = null;
  times: number = 0;
  //上次访问时间
  visitTime: Date | null = null;
  parent: Matter | null = null;
  user: User = new User();
  // 文件是否被软删除
  deleted: boolean = false;
  checkContent:boolean = false;
  deleteTime: Date | null = null;
  spaceUuid: string | null = null;
  //上传审批
  approval:number = 0;
  approvalRemark :string = '';
  //外发审批
  outsendStatus:number = 0;
  outsendRemark:string = '';
  /*
    这部分是辅助UI的字段信息
     */
  //作为勾选变量
  check: boolean = false;
  editMode: boolean = false;

  //允许用户选择的文件类型
  filter: string = '*';
  //本地字段
  //给用户的提示文字
  uploadHint: string | null = null;
  //浏览器中选择好的原生file，未作任何处理。
  file: File | null = null;
  //当前上传进度的数值 0-1之间
  progress: number = 0;
  //实时上传速度 byte/s
  speed: number = 0;
  //取消上传source
  cancelSource: CancelTokenSource = axios.CancelToken.source();

  static URL_MATTER_CREATE_DIRECTORY = '/api/matter/create/directory';
  static URL_MATTER_SOFT_DELETE = '/api/matter/soft/delete';
  static URL_MATTER_APPROVAL = '/api/matter/approval';
  static URL_MATTER_SOFT_DELETE_BATCH = '/api/matter/soft/delete/batch';
  static URL_MATTER_RECOVERY = '/api/matter/recovery';
  static URL_MATTER_RECOVERY_BATCH = '/api/matter/recovery/batch';
  static URL_MATTER_DELETE = '/api/matter/delete';
  static URL_MATTER_DELETE_BATCH = '/api/matter/delete/batch';
  static URL_MATTER_RENAME = '/api/matter/rename';
  static URL_CHANGE_PRIVACY = '/api/matter/change/privacy';
  static URL_MATTER_MOVE = '/api/matter/move';
  static URL_MATTER_UPLOAD = '/api/matter/upload';
  static URL_MATTER_ZIP = '/api/matter/download';
  private static _downloading = false;
  static URL_MATTER_CRAWL = '/api/matter/crawl';
  static URL_MATTER_OUTSENTAPPLY = '/api/matter/outsendapply';
  static URL_MATTER_FORWARD = '/api/matter/forward';
  static URL_MATTER_PDF_TO_IMAGE = '/api/matter/pdf2img';
  static MATTER_ROOT = 'root';

  /*static downloadZip(uuidsString: string, spaceUuid: string) {
    const url = `${EnvUtil.currentHost()}${Matter.URL_MATTER_ZIP}?uuids=${uuidsString}&spaceUuid=${spaceUuid}`;
    
    // 创建隐藏的 iframe 来捕获响应
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    
    // 监听 iframe 加载完成
    iframe.onload = function() {
      try {
        // 尝试获取 iframe 的内容
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
        const content = iframeDoc?.body.innerText;
        
        // 检查是否是 JSON 错误响应
        if (content && content.includes('"code":"BAD_REQUEST"')) {
          try {
            const errorData = JSON.parse(content);
            MessageBoxUtil.error(errorData.msg || Lang.t('operationFailed'));
          } catch (e) {
            MessageBoxUtil.error(Lang.t('operationFailed'));
          }
        }
      } catch (e) {
        // 忽略错误
      }
      
      // 清理
      setTimeout(() => document.body.removeChild(iframe), 1000);
    };
    
    document.body.appendChild(iframe);
  }*/
  static downloadZip(uuidsString: string, spaceUuid: string, downloadTokenUuid?: string, downloadUrl?: string) {
    if (Matter._downloading) {
      message.warning(Lang.t('downloading') || '正在下载中，请稍候...');
      return;
    }
    Matter._downloading = true;

    let url = downloadUrl || `${EnvUtil.currentHost()}${Matter.URL_MATTER_ZIP}?uuids=${encodeURIComponent(uuidsString)}&spaceUuid=${encodeURIComponent(spaceUuid)}`;
    
    if (!downloadUrl && downloadTokenUuid) {
        url += `&downloadTokenUuid=${encodeURIComponent(downloadTokenUuid)}`;
    }
    
    const loadingMsg = message.loading(Lang.t('downloading') || '正在下载，请稍候...', 0);
    
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    
    let finished = false;
    let pollTimer: any = null;
    
    const cleanup = () => {
        if (!finished) {
            finished = true;
            Matter._downloading = false;
            if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
            loadingMsg();
            setTimeout(() => {
                try { document.body.removeChild(iframe); } catch(e) {}
            }, 500);
        }
    };
    
    iframe.onload = function() {
        try {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
            const content = iframeDoc?.body?.innerText || '';
            
            if (content && (content.includes('"code"') || content.includes('"msg"'))) {
                try {
                    const errorData = JSON.parse(content);
                    if (errorData.code && errorData.code !== 'OK') {
                        MessageBoxUtil.error(errorData.msg || Lang.t('operationFailed'));
                    }
                } catch (e) {
                    if (content.includes('BAD_REQUEST') || content.includes('LOGIN')) {
                        MessageBoxUtil.error(Lang.t('operationFailed'));
                    }
                }
            }
        } catch (e) {}
        cleanup();
    };
    
    iframe.onerror = function() {
        MessageBoxUtil.error(Lang.t('operationFailed'));
        cleanup();
    };
    
    iframe.src = url;
    document.body.appendChild(iframe);
    
    // polling检测：文件下载时iframe的onload可能不触发，通过检查iframe状态兜底
    pollTimer = setInterval(() => {
        if (finished) return;
        try {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
            if (iframeDoc) {
                const content = iframeDoc.body?.innerText || '';
                const ct = iframeDoc.contentType || '';
                // 如果检测到JSON错误响应，立即处理
                if (content && (content.includes('"code"') || content.includes('"msg"'))) {
                    try {
                        const errorData = JSON.parse(content);
                        if (errorData.code && errorData.code !== 'OK') {
                            MessageBoxUtil.error(errorData.msg || Lang.t('operationFailed'));
                        }
                    } catch (e) {}
                    cleanup();
                    return;
                }
                // 非HTML内容（文件下载），onload可能未触发，手动清理
                if (ct && !ct.includes('text/html') && !ct.includes('json')) {
                    cleanup();
                    return;
                }
            }
        } catch (e) {
            // 跨域或iframe已导航到下载，说明下载已开始
            cleanup();
            return;
        }
    }, 2000);
    
    // 兜底超时：30秒（文件下载通常几秒内完成，大文件看服务端生成速度）
    setTimeout(() => {
        if (!finished) {
            cleanup();
        }
    }, 30000);
}
  constructor(reactComponent?: React.Component) {
    super(reactComponent);
  }

  assign(obj: any) {
    super.assign(obj);
    this.assignEntity('parent', Matter);
    this.assignEntity('user', User);
    this.assignEntity('visitTime', Date);
    this.assignEntity('deleteTime', Date);
  }

  getTAG(): string {
    return 'matter';
  }

  getForm(): any {
    return {
      userUuid: this.userUuid,
      puuid: this.puuid,
      uuid: this.uuid ? this.uuid : null,
      dir: this.dir,
      alien: this.alien,
      name: this.name,
      md5: this.md5,
      size: this.size,
      privacy: this.privacy,
      path: this.path,
      times: this.times,
      parent: this.parent,
    };
  }

  getFilters(): Filter[] {
    return [
      ...super.getFilters(),
      new InputFilter('父级菜单uuid', 'puuid', null, false),
      new InputFilter('用户', 'userUuid', null, false),
      new InputFilter('关键字', 'name'),
      new CheckFilter('文件夹', 'dir'),
      new CheckFilter('应用数据', 'alien',false),
      new CheckFilter('删除', 'deleted'),
      new CheckFilter('全文检索', 'checkContent'),
      new SortFilter('文件夹', 'orderDir',false),
      new SortFilter('下载次数', 'orderTimes',false),
      new SortFilter('大小', 'orderSize',false),
      new SortFilter('名称', 'orderName',false),
      new InputFilter('后缀名', 'extensions'),
      new InputFilter('分享uuid', 'shareUuid',null,false),
      new InputFilter('提取码', 'shareCode',null,false),
      new InputFilter('分享根目录', 'shareRootUuid',null,false),
      new SortFilter('删除时间排序', 'orderDeleteTime',false),
      new InputFilter('空间uuid', 'spaceUuid',null,false),
      new InputFilter('跨组检索', 'crossGroup',null,false),
      new InputFilter('审批状态','approval',null,false),
      new InputFilter('外发状态','outsendStatus',null,false),
    ];
  }

  getUrlPrefix() {
    return '/api/matter';
  }

  isImage() {
    return FileUtil.isImage(this.name);
  }

  getIcon() {
    if (FileUtil.isImage(this.name)) {
      return ImageUtil.handleImageUrl(this.getPreviewUrl(), false, 100, 100);
    } else {
      return FileUtil.getIcon(this.name, this.dir);
    }
  }

  //下载文件
 /* download(downloadUrl?: string | null) {
    if (!downloadUrl) {
      downloadUrl = this.getDownloadUrl();
    }
    window.open(downloadUrl);
  }*/
  // 修改后
download(downloadUrl?: string | null) {
  // 如果当前文件没有 UUID，则无法下载
  if (!this.uuid) {
      MessageBoxUtil.error(Lang.t('matter.downloadFailed'));
      return;
  }

  // 从传入的 downloadUrl 中提取 downloadTokenUuid（如果存在）
  let token: string | undefined;
  if (downloadUrl) {
      const match = downloadUrl.match(/[?&]downloadTokenUuid=([^&]+)/);
      token = match ? match[1] : undefined;
  }

  // 调用统一的 downloadZip 接口（单个文件）
  Matter.downloadZip(this.uuid, this.spaceUuid || '', token);
}
/**
 * 获取安全的预览 URL（不包含文件名，防止特殊字符破坏）
 * @param downloadTokenUuid 可选的下载令牌（用于私有分享）
 * @returns 预览 URL
 */
getSafePreviewUrl(downloadTokenUuid?: string): string {
  // 假设后端预览接口为 /api/alien/preview/{uuid}
  let url = `${EnvUtil.currentHost()}/api/alien/preview/${this.uuid}`;
  const params = new URLSearchParams();
  if (this.spaceUuid) {
      params.append('spaceUuid', this.spaceUuid);
  }
  if (downloadTokenUuid) {
      params.append('downloadTokenUuid', downloadTokenUuid);
  }
  const query = params.toString();
  if (query) {
      url += '?' + query;
  }
  return url;
}
  //预览文件
  preview(
    previewUrl?: string,
    hasDownloadPermission?: boolean,
    hasPrintPermission?: boolean
  ) {
    console.log('Preview URL:', previewUrl);
    console.log('Preview parameters:', { 
      hasDownloadPermission, 
      hasPrintPermission
    });

    // 如果没有传入 previewUrl，则从当前对象获取
    if (!previewUrl) {
      previewUrl = this.getPreviewUrl();
    }

    // 调用 PreviewerHelper，传递正确的参数
    PreviewerHelper.preview(
      this,  // matter 对象
      previewUrl,
      hasDownloadPermission,
      hasPrintPermission
    );
  }

  private getFileName(): string | null {
    return this.name || null;
  }

  // 在 Matter 类中添加外发审计方法
  httpOutsendApply(
    reason: string, 
    remark: string, 
    successCallback?: any, 
    errorCallback?: any,
    finallyCallback?: any
  ) {
    let that = this;
    
    this.httpPost(
      Matter.URL_MATTER_OUTSENTAPPLY,
      {
        uuid: this.uuid,
        reason: reason,
        remark: remark,
        spaceUuid: this.spaceUuid
      },
      function (response: any) {
        // 更新外发审计状态（根据实际API响应调整）
        // 假设API返回的数据中包含 outsendStatus 和 outsendRemark
        if (response.data?.data) {
          that.outsendStatus = response.data.data.outsendStatus;
          that.outsendRemark = response.data.data.outsendRemark;
        }
        
        SafeUtil.safeCallback(successCallback)(response);
      },
      function (err: any) {
        if (typeof errorCallback === 'function') {
          errorCallback(that.getErrorMessage(err), err);
        } else {
          that.defaultErrorHandler(err, errorCallback);
        }
      },
      finallyCallback
    );
  }

  httpApproval(successCallback?: any, errorCallback?: any, finallyCallback?: any) {
    let that = this;
    
    this.httpPost(
      Matter.URL_MATTER_APPROVAL,
      {
        uuid: this.uuid,
        approval: this.approval,
        approvalRemark: this.approvalRemark,
        outsendStatus: this.outsendStatus,
        outsendRemark: this.outsendRemark,
        spaceUuid: this.spaceUuid
      },
      function (response: any) {
        // 更新审批状态
        that.approval = response.data.data.approval;
        that.approvalRemark = response.data.data.approvalRemark;
        that.outsendStatus = response.data.data.outsendStatus;
        that.outsendRemark = response.data.data.outsendRemark;     
        SafeUtil.safeCallback(successCallback)(response);
      },
      function (err: any) {
        if (typeof errorCallback === 'function') {
          errorCallback(that.getErrorMessage(err), err);
        } else {
          that.defaultErrorHandler(err, errorCallback);
        }
      },
      finallyCallback
    );
  }

  /**
   * 转发文件/文件夹到个人空间
   * @param successCallback 成功回调
   * @param errorCallback 错误回调
   * @param finallyCallback 最终回调
   */
  httpForwardToPersonalSpace(
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {
    let that = this;
    
    this.httpPost(
      Matter.URL_MATTER_FORWARD,
      {
        uuid: this.uuid,
        targetSpaceType: 'personal', // 指定目标空间类型为个人空间
        spaceUuid: this.spaceUuid
      },
      function (response: any) {
        SafeUtil.safeCallback(successCallback)(response);
      },
      function (err: any) {
        if (typeof errorCallback === 'function') {
          errorCallback(that.getErrorMessage(err), err);
        } else {
          that.defaultErrorHandler(err, errorCallback);
        }
      },
      finallyCallback
    );
  }

  /**
   * 批量转发文件/文件夹到个人空间
   * @param uuids 要转发的文件UUID列表
   * @param spaceUuid 源空间UUID
   * @param successCallback 成功回调
   * @param errorCallback 错误回调
   * @param finallyCallback 最终回调
   */
  static httpForwardBatchToPersonalSpace(
    uuids: string[],
    spaceUuid: string,
    taskId?: string | null,
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {
    const form: any = {
      uuids: uuids,
      targetSpaceType: 'personal', // 指定目标空间类型为个人空间
      spaceUuid: spaceUuid
    };
    if (taskId) form.taskId = taskId;
    new HttpBase().httpPost(
      Matter.URL_MATTER_FORWARD,
      form,
      function (response: any) {
        SafeUtil.safeCallback(successCallback)(response);
      },
      errorCallback,
      finallyCallback
    );
  }

  /**
   * 转发文件/文件夹到指定用户
   * @param targetUserUuids 目标用户UUID列表
   * @param successCallback 成功回调
   * @param errorCallback 错误回调
   * @param finallyCallback 最终回调
   */
  httpForward(
    targetUserUuids: string[],
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {
    let that = this;
    
    this.httpPost(
      Matter.URL_MATTER_FORWARD,
      {
        uuid: this.uuid,
        targetUserUuids: targetUserUuids,
        spaceUuid: this.spaceUuid
      },
      function (response: any) {
        SafeUtil.safeCallback(successCallback)(response);
      },
      function (err: any) {
        if (typeof errorCallback === 'function') {
          errorCallback(that.getErrorMessage(err), err);
        } else {
          that.defaultErrorHandler(err, errorCallback);
        }
      },
      finallyCallback
    );
  }

  /**
   * 批量转发文件/文件夹到指定用户
   * @param uuids 要转发的文件UUID列表
   * @param targetUserUuids 目标用户UUID列表
   * @param spaceUuid 空间UUID
   * @param successCallback 成功回调
   * @param errorCallback 错误回调
   * @param finallyCallback 最终回调
   */
  static httpForwardBatch(
    uuids: string[],
    targetUserUuids: string[],
    spaceUuid: string,
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {
    new HttpBase().httpPost(
      Matter.URL_MATTER_FORWARD,
      {
        uuids: uuids,
        targetUserUuids: targetUserUuids,
        spaceUuid: spaceUuid
      },
      function (response: any) {
        SafeUtil.safeCallback(successCallback)(response);
      },
      errorCallback,
      finallyCallback
    );
  }

  httpCreateDirectory(
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {
    let that = this;
    let form = {
      name: this.name,
      puuid: this.puuid,
      spaceUuid: this.spaceUuid,
    };

    return this.httpPost(
      Matter.URL_MATTER_CREATE_DIRECTORY,
      form,
      function (response: any) {
        that.assign(response.data.data);
        typeof successCallback === 'function' && successCallback(response);
      },
      errorCallback,
      finallyCallback
    );
  }

  httpSoftDelete(successCallback?: any, errorCallback?: any) {
    this.httpPost(
      Matter.URL_MATTER_SOFT_DELETE,
      { uuid: this.uuid, spaceUuid: this.spaceUuid },
      function (response: any) {
        typeof successCallback === 'function' && successCallback(response);
      },
      errorCallback
    );
  }

  static httpSoftDeleteBatch(
    uuids: string,
    spaceUuid: string,
    successCallback?: any,
    errorCallback?: any
  ) {
    new HttpBase().httpPost(
      Matter.URL_MATTER_SOFT_DELETE_BATCH,
      { uuids, spaceUuid },
      function (response: any) {
        typeof successCallback === 'function' && successCallback(response);
      },
      errorCallback
    );
  }

  httpDelete(successCallback?: any, errorCallback?: any) {
    this.httpPost(
      Matter.URL_MATTER_DELETE,
      { uuid: this.uuid, spaceUuid: this.spaceUuid },
      function (response: any) {
        typeof successCallback === 'function' && successCallback(response);
      },
      errorCallback
    );
  }

  static httpCrawl(
    body: {
      url: string;
      puuid: string;
      filename: string;
      spaceUuid: string;
    },
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {
    new HttpBase().httpPost(
      Matter.URL_MATTER_CRAWL,
      body,
      function (response: any) {
        typeof successCallback === 'function' && successCallback(response);
      },
      errorCallback,
      finallyCallback
    );
  }

  static httpDeleteBatch(
    uuids: string,
    spaceUuid: string,
    successCallback?: any,
    errorCallback?: any
  ) {
    new HttpBase().httpPost(
      Matter.URL_MATTER_DELETE_BATCH,
      { uuids, spaceUuid },
      function (response: any) {
        typeof successCallback === 'function' && successCallback(response);
      },
      errorCallback
    );
  }

  httpRecovery(successCallback?: any, errorCallback?: any) {
    this.httpPost(
      Matter.URL_MATTER_RECOVERY,
      { uuid: this.uuid },
      function (response: any) {
        typeof successCallback === 'function' && successCallback(response);
      },
      errorCallback
    );
  }

  static httpRecoveryBatch(
    uuids: string,
    successCallback?: any,
    errorCallback?: any
  ) {
    new HttpBase().httpPost(
      Matter.URL_MATTER_RECOVERY_BATCH,
      { uuids: uuids },
      function (response: any) {
        typeof successCallback === 'function' && successCallback(response);
      },
      errorCallback
    );
  }

  httpDetail(
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {
    let that = this;
    if (!this.uuid) {
      this.errorMessage = 'uuid未指定，无法获取到详情！';

      this.defaultErrorHandler(this.errorMessage, errorCallback);

      return;
    }

    this.detailLoading = true;

    this.httpGet(
      this.getUrlDetail(),
      {
        uuid: this.uuid,
        spaceUuid: this.spaceUuid,
      },
      function (response: any) {
        that.detailLoading = false;

        that.assign(response.data.data);

        SafeUtil.safeCallback(successCallback)(response);
      },
      function (response: any) {
        that.detailLoading = false;

        if (typeof errorCallback === 'function') {
          errorCallback(that.getErrorMessage(response), response);
        } else {
          //没有传入错误处理的方法就采用默认处理方法：toast弹出该错误信息。
          that.defaultErrorHandler(response);
        }
      },
      finallyCallback
    );
  }

  httpRename(
    name: string,
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {
    let that = this;
    this.httpPost(
      Matter.URL_MATTER_RENAME,
      { uuid: this.uuid, spaceUuid: this.spaceUuid, name: name },
      function (response: any) {
        that.assign(response.data.data);
        typeof successCallback === 'function' && successCallback(response);
      },
      errorCallback,
      finallyCallback
    );
  }

  httpChangePrivacy(
    privacy: boolean,
    successCallback?: any,
    errorCallback?: any
  ) {
    let that = this;
    this.httpPost(
      Matter.URL_CHANGE_PRIVACY,
      { uuid: this.uuid, privacy: privacy, spaceUuid: this.spaceUuid },
      function (response: any) {
        that.privacy = privacy;
        if (typeof successCallback === 'function') {
          successCallback(response);
          message.success(response.data.msg);
        } else {
          message.success(response.data.msg);
        }
      },
      errorCallback
    );
  }

  static httpMove(
    spaceUuid: string,
    srcUuids: string,
    destUuid: string,
    successCallback?: any,
    errorCallback?: any
  ) {
    let form: any = { spaceUuid, srcUuids };
    if (destUuid) {
      form.destUuid = destUuid;
    } else {
      form.destUuid = 'root';
    }
    new HttpBase().httpPost(
      Matter.URL_MATTER_MOVE,
      form,
      function (response: any) {
        typeof successCallback === 'function' && successCallback(response);
      },
      errorCallback
    );
  }

  /*
    以下是和上传相关的内容。
     */

  //从file中装填metaData
  validate() {
    if (!this.file) {
      this.errorMessage = '请选择上传文件';
      return false;
    }

    this.name = this.file.name;
    if (!this.name) {
      this.errorMessage = '请选择上传文件';
      return false;
    }

    this.size = this.file.size;

    this.errorMessage = null;
    return true;
  }

  //验证过滤器有没有误填写，这个方法主要给开发者使用。
  validateFilter() {
    let filter = this.filter;
    if (filter === null || filter === '') {
      this.errorMessage = '过滤器设置错误，请检查-1';
      console.error('过滤器设置错误，请检查.-1');
      return false;
    }
    if (filter !== '*') {
      let regex1 = /^(image|audio|video|text)(\|(image|audio|video|text))*$/g;
      let regex2 = /^(\.[\w]+)(\|\.[\w]+)*$/;
      // 测试几种特殊类型 image|audio|video|text

        if (!regex1.test(filter)) {
          //测试后缀名
          if (!regex2.test(filter)) {
              this.errorMessage = Lang.t('settingError2');
              console.error(Lang.t('settingError2'));
              return false;
          }
      }
    }

    //validate privacy
    let privacy = this.privacy;
    if (!privacy) {
      if (privacy !== false) {
        this.errorMessage = 'privacy属性为Boolean类型';
        console.error('privacy属性为Boolean类型.');
        return false;
      }
    }

    return true;
  }

  //验证用户上传的文件是否符合过滤器
  validateFileType() {
    if (!this.filter) {
      this.errorMessage = Lang.t('conditionError');
      return false;
    }
    if (this.filter === '*') {
      this.errorMessage = null;
      return true;
    }

    let type = MimeUtil.getMimeType(this.name);
    let extension = MimeUtil.getExtension(this.name);
    let simpleType = type.substring(0, type.indexOf('/'));

    //专门解决android微信浏览器中名字乱命名的bug.
    if (StringUtil.startWith(this.name, 'image%3A')) {
      extension = 'jpg';
      simpleType = 'image';
    } else if (StringUtil.startWith(this.name, 'video%3A')) {
      extension = 'mp4';
      simpleType = 'video';
    } else if (StringUtil.startWith(this.name, 'audio%3A')) {
      extension = 'mp3';
      simpleType = 'audio';
    }

    if (StringUtil.containStr(this.filter, extension)) {
      this.errorMessage = null;
      return true;
    }

    if (simpleType) {
      if (StringUtil.containStr(this.filter, simpleType)) {
        this.errorMessage = null;
        return true;
      }
    }
    this.errorMessage = Lang.t('formatError');
    return false;
  }

  // 文件上传
  httpUpload(successCallback?: any, failureCallback?: any) {
    let that = this;

    console.log('开始上传，文件名:', this.file?.name);
    console.log('当前uuid:', this.uuid);
    console.log('当前spaceUuid:', this.spaceUuid);

    //验证是否装填好
    if (!this.validate()) {
      console.log('验证失败:', this.errorMessage);
      return;
    }

    //验证用户填写的过滤条件是否正确
    if (!this.validateFilter()) {
      console.log('过滤器验证失败:', this.errorMessage);
      return;
    }

    //验证是否满足过滤器
    if (!this.validateFileType()) {
      console.log('文件类型验证失败');
      MessageBoxUtil.error('文件类型不满足，请重试');
      return;
    }

    // 新增：获取偏好设置并检查禁止的扩展名
    this.checkForbiddenExtensionsBeforeUpload(successCallback, failureCallback);
  }
  
  private checkForbiddenExtensionsBeforeUpload(successCallback?: any, failureCallback?: any) {
    let that = this;

    Matter.fetchForbiddenExtensions().then(function (config) {
      if (config.enabled && config.extensions.length > 0) {
        const fileName = that.file?.name || '';
        let fileExt = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
        if (!fileExt.startsWith('.') && fileExt) {
          fileExt = '.' + fileExt;
        }

        if (config.extensions.includes(fileExt)) {
          const errorMessage = `文件类型 ${fileExt} 被禁止上传`;
          console.log('文件扩展名检查失败，应该被拦截:', errorMessage);
          that.errorMessage = errorMessage;
          that.clear();
          MessageBoxUtil.error(errorMessage);
          if (typeof failureCallback === 'function') {
            failureCallback(errorMessage, { isForbiddenExtension: true });
          }
          return;
        }
      }

      that.executeFileUpload(successCallback, failureCallback);
    });
  }

  // 在 Matter 类中添加
  downloadWithShare(shareUuid: string, shareCode: string, rootUuid: string) {
    const downloadUrl = `${this.getShareDownloadUrl(shareUuid, shareCode, rootUuid)}`;
    window.open(downloadUrl, '_blank');
  }

  getShareDownloadUrl(shareUuid: string, shareCode: string | null, rootUuid: string): string {
    let url = `${EnvUtil.currentHost()}/api/share/matter/download?shareUuid=${shareUuid}&matterUuid=${this.uuid}&shareRootUuid=${rootUuid}`;
    if (shareCode) {
      url += `&shareCode=${shareCode}`;
    }
    return url;
  }

  private executeFileUpload(successCallback?: any, failureCallback?: any, preference?: any) {
    let that = this;
  
    let formData = new FormData();
    formData.append('spaceUuid', that.spaceUuid!);
    formData.append('puuid', that.puuid);
    formData.append('file', that.file!);
    formData.append('alien', that.alien.toString());
    formData.append('privacy', that.privacy.toString());
    
    if (preference) {
      formData.append('preferenceCheck', 'true');
    }
  
    let lastTimeStamp = new Date().getTime();
    let lastSize = 0;
  
    that.loading = true;
    HttpUtil.httpPostFile(
      Matter.URL_MATTER_UPLOAD,
      formData,
      function (response: any) {
        // 检查是否是错误响应（由于validateStatus=true，错误也会进入这里）
        if (response.status >= 400) {
          that.handleErrorResponse(response, failureCallback);
          return;
        }
        
        // 真正的成功
        that.uuid = response.data.data.uuid;
        SafeUtil.safeCallback(successCallback)(response);
      },
      function (err: any) {
        that.handleUploadError(err, failureCallback);
      },
      function () {
        that.loading = false;
        that.updateUI();
      },
      function (event: any) {
        that.progress = event.loaded / event.total;
  
        let currentTime = new Date().getTime();
        let deltaTime = currentTime - lastTimeStamp;
  
        if (deltaTime > 1000) {
          lastTimeStamp = currentTime;
          let currentSize = event.loaded;
          let deltaSize = currentSize - lastSize;
          lastSize = currentSize;
          that.speed = NumberUtil.parseInt(
            (deltaSize / (deltaTime / 1000)).toFixed(0)
          );
        }
        that.updateUI();
      },
      {
        cancelToken: that.cancelSource.token,
        // 关键修改：只有2xx状态码是成功
        validateStatus: function (status: number) {
          return status >= 200 && status < 300;
        },
        timeout: 0,
        responseType: 'json',
      }
    );
  }
  
  // 新增错误处理方法
  private handleUploadError(err: any, failureCallback?: any) {
    let that = this;
    
    if (axios.isCancel(err)) {
      that.clear();
      SafeUtil.safeCallback(failureCallback)();
      return;
    }
    
    let errorMessage = Lang.t('operationFailed');
    
    // 简化错误处理
    if (err.response && err.response.data) {
      const data = err.response.data;
      
      if (typeof data === 'object') {
        errorMessage = data.msg || data.message || data.error || errorMessage;
      } else if (typeof data === 'string') {
        errorMessage = data;
      }
    } else if (err.message) {
      errorMessage = err.message;
    }
    
    that.errorMessage = errorMessage;
    that.clear();
    
    // 显示错误消息
    setTimeout(() => {
      MessageBoxUtil.error(errorMessage);
    }, 100);
    
    if (typeof failureCallback === 'function') {
      failureCallback(errorMessage, err);
    }
  }
  
  // 处理成功回调中的错误响应
  private handleErrorResponse(response: any, failureCallback?: any) {
    let that = this;
    let errorMessage = Lang.t('operationFailed');
    
    if (response.data) {
      const data = response.data;
      if (typeof data === 'object') {
        errorMessage = data.msg || data.message || data.error || errorMessage;
      } else if (typeof data === 'string') {
        errorMessage = data;
      }
    }
    
    that.errorMessage = `HTTP ${response.status}: ${errorMessage}`;
    that.clear();
    
    setTimeout(() => {
      MessageBoxUtil.error(errorMessage || Lang.t('operationFailed'));
    }, 100);
    
    if (typeof failureCallback === 'function') {
      failureCallback(that.errorMessage, { response: response });
    }
  }

  cancelUpload() {
    this.cancelSource.cancel();
  }

  //清除文件
  clear() {
    // 只清除上传相关的状态，保留基本信息
    this.loading = false;
    this.progress = 0;
    this.speed = 0;
    this.cancelSource = axios.CancelToken.source();
    this.errorMessage = '';
    
    // 注意：不要重置 file 属性，因为其他地方可能需要引用
    // this.file = null;
    
    // 更新UI
    this.updateUI();
  }

  /*getPreviewUrl(downloadTokenUuid?: string): string {
    return `${EnvUtil.currentHost()}/api/alien/preview/${this.uuid}/${
      this.name
    }${downloadTokenUuid ? '?downloadTokenUuid=' + downloadTokenUuid : ''}`;
  }*/
  getPreviewUrl(downloadTokenUuid?: string): string {
    const encodedName = encodeURIComponent(this.name || '');
    let url = `${EnvUtil.currentHost()}/api/alien/preview/${this.uuid}/${encodedName}`;
    if (downloadTokenUuid) {
        url += `?downloadTokenUuid=${encodeURIComponent(downloadTokenUuid)}`;
    }
    return url;
}
  getDownloadUrl(downloadTokenUuid?: string): string {
    // 对文件名进行编码，防止特殊字符破坏URL
    const encodedName = encodeURIComponent(this.name || '');
    return `${EnvUtil.currentHost()}/api/alien/download/${this.uuid}/${encodedName}${downloadTokenUuid ? '?downloadTokenUuid=' + downloadTokenUuid : ''}`;
  }

  getSharePreviewUrl(shareUuid: string, shareCode: string | null, rootUuid: string): string {
    let url = `${EnvUtil.currentHost()}/api/share/matter/preview?shareUuid=${shareUuid}&matterUuid=${this.uuid}&shareRootUuid=${rootUuid}`;
    if (shareCode) {
      url += `&shareCode=${shareCode}`;
    }
    return url;
  }

  /**
   * PDF转图片
   * @param format 图片格式 PNG|JPEG|TIFF|SVG
   * @param successCallback 成功回调
   * @param errorCallback 错误回调
   * @param finallyCallback 最终回调
   */
  httpPdfToImage(
    format: string,
    successCallback?: (response: any) => void,
    errorCallback?: (message: string, err?: any) => void,
    finallyCallback?: () => void
  ) {
    let that = this;
    
    // 创建下载链接
    const downloadUrl = `${EnvUtil.currentHost()}${Matter.URL_MATTER_PDF_TO_IMAGE}?uuid=${this.uuid}&format=${format}&spaceUuid=${this.spaceUuid}&t=${Date.now()}`;
    
    // 使用 iframe 下载
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = downloadUrl;
    
    let downloadCompleted = false;
    
    // 设置超时检测
    const timeoutId = setTimeout(() => {
      if (!downloadCompleted) {
        downloadCompleted = true;
        SafeUtil.safeCallback(successCallback)({ 
          success: true, 
          fileType: 'unknown'
        });
        SafeUtil.safeCallback(finallyCallback)();
        cleanup();
      }
    }, 5000);
    
    const cleanup = () => {
      clearTimeout(timeoutId);
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }, 1000);
    };
    
    iframe.onload = function() {
      if (!downloadCompleted) {
        downloadCompleted = true;
        try {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
          const content = iframeDoc?.body.innerText;
          
          if (content && content.includes('"code":"BAD_REQUEST"')) {
            try {
              const errorData = JSON.parse(content);
              if (typeof errorCallback === 'function') {
                errorCallback(errorData.msg || Lang.t('operationFailed'));
              } else {
                MessageBoxUtil.error(errorData.msg || Lang.t('operationFailed'));
              }
            } catch (e) {
              if (typeof errorCallback === 'function') {
                errorCallback(Lang.t('operationFailed'));
              } else {
                MessageBoxUtil.error(Lang.t('operationFailed'));
              }
            }
          } else {
            SafeUtil.safeCallback(successCallback)({ 
              success: true, 
              fileType: 'unknown'
            });
          }
        } catch (e) {
          SafeUtil.safeCallback(successCallback)({ 
            success: true, 
            fileType: 'unknown'
          });
        }
        SafeUtil.safeCallback(finallyCallback)();
        cleanup();
      }
    };
    
    iframe.onerror = function() {
      if (!downloadCompleted) {
        downloadCompleted = true;
        if (typeof errorCallback === 'function') {
          errorCallback(Lang.t('matter.pdfConvertFailed'));
        } else {
          MessageBoxUtil.error(Lang.t('matter.pdfConvertFailed'));
        }
        SafeUtil.safeCallback(finallyCallback)();
        cleanup();
      }
    };
    
    document.body.appendChild(iframe);
  }

  /**
   * 通用的API POST请求方法
   * @param url 请求URL
   * @param data 请求数据
   * @param successCallback 成功回调
   * @param errorCallback 错误回调
   * @param finallyCallback 最终回调
   */
  httpApiPost(
    url: string,
    data: any,
    successCallback?: (response: any) => void,
    errorCallback?: (message: string, err?: any) => void,
    finallyCallback?: () => void
  ) {
    let that = this;
    
    this.httpPost(
      url,
      data,
      function (response: any) {
        SafeUtil.safeCallback(successCallback)(response);
      },
      function (err: any) {
        if (typeof errorCallback === 'function') {
          errorCallback(that.getErrorMessage(err), err);
        } else {
          that.defaultErrorHandler(err, errorCallback);
        }
      },
      finallyCallback
    );
  }

  /**
   * 个人空间转组空间（转发到指定用户的个人空间）
   * @param targetUserUuids 目标用户UUID列表
   * @param successCallback 成功回调
   * @param errorCallback 错误回调
   * @param finallyCallback 最终回调
   */
  httpForwardToUsers(
    targetUserUuids: string[],
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {
    let that = this;
    
    this.httpPost(
      Matter.URL_MATTER_FORWARD,
      {
        uuid: this.uuid,
        targetUserUuids: targetUserUuids,
        spaceUuid: this.spaceUuid
      },
      function (response: any) {
        SafeUtil.safeCallback(successCallback)(response);
      },
      function (err: any) {
        if (typeof errorCallback === 'function') {
          errorCallback(that.getErrorMessage(err), err);
        } else {
          that.defaultErrorHandler(err, errorCallback);
        }
      },
      finallyCallback
    );
  }

  /**
   * 批量个人空间转组空间（批量转发到指定用户的个人空间）
   * @param uuids 要转发的文件UUID列表
   * @param targetUserUuids 目标用户UUID列表
   * @param spaceUuid 源空间UUID
   * @param successCallback 成功回调
   * @param errorCallback 错误回调
   * @param finallyCallback 最终回调
   */
  static httpForwardBatchToUsers(
    uuids: string[],
    targetUserUuids: string[],
    spaceUuid: string,
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {
    new HttpBase().httpPost(
      Matter.URL_MATTER_FORWARD,
      {
        uuids: uuids,
        targetUserUuids: targetUserUuids,
        spaceUuid: spaceUuid
      },
      function (response: any) {
        SafeUtil.safeCallback(successCallback)(response);
      },
      errorCallback,
      finallyCallback
    );
  }

  /**
   * 批量转发文件/文件夹到组空间
   * @param uuids 要转发的文件UUID列表
   * @param targetSpaceUuids 目标空间UUID列表
   * @param spaceUuid 源空间UUID
   * @param successCallback 成功回调
   * @param errorCallback 错误回调
   * @param finallyCallback 最终回调
   */
  static httpForwardBatchToGroupSpaces(
    uuids: string[],
    targetSpaceUuids: string[],  // 修改：传递空间UUID而不是用户UUID
    spaceUuid: string,
    taskId?: string | null,
    successCallback?: any,
    errorCallback?: any,
    finallyCallback?: any
  ) {
    const form: any = {
      uuids: uuids,
      targetSpaceUuids: targetSpaceUuids,  // 传递所有目标空间UUID，支持同时转发到多个组空间
      spaceUuid: spaceUuid
    };
    if (taskId) form.taskId = taskId;
    new HttpBase().httpPost(
      Matter.URL_MATTER_FORWARD,
      form,
      function (response: any) {
        SafeUtil.safeCallback(successCallback)(response);
      },
      errorCallback,
      finallyCallback
    );
  }

  /**
   * 查询转发任务的实时进度（配合后端 /api/matter/forwardProgress 轮询）
   * @param taskId 转发任务ID
   * @param successCallback 成功回调（返回任务进度快照）
   * @param errorCallback 错误回调
   */
  static httpForwardProgress(taskId: string, successCallback?: any, errorCallback?: any) {
    new HttpBase().httpGet(
      '/api/matter/forwardProgress',
      { taskId: taskId },
      function (response: any) {
        SafeUtil.safeCallback(successCallback)(response);
      },
      errorCallback
    );
  }
}